/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  menus: []
};

const dropDownReducer = (state = initialState, action) => {
  const { menus } = state;
  const dropDownMenus = menus.slice(0);
  const { newMenu, id, menuType } = action;
  const existentMenu = dropDownMenus.find(menu => menu.id === id);
  const data = {
    id,
    type: menuType,
    dropDown: {
      ...newMenu
    }
  };

  switch (action.type) {
    case Types.TOGGLE_DROP_DOWN_MENU:
      if (existentMenu) {
        return {
          ...state,
          menus: dropDownMenus.filter(menu => menu.id !== id)
        };
      }
      return {
        ...state,
        menus: [data]
      };
    case Types.REMOVE_DROP_DOWN_MENU:
      return {
        ...state,
        menus: dropDownMenus.filter(menu => menu.id !== id)
      };
    case Types.REMOVE_ALL_DROP_DOWN_MENU:
      return {
        ...state,
        menus: []
      };
    default:
      return state;
  }
};

export default dropDownReducer;
